import { ApolloClient, from, InMemoryCache, makeVar } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from "apollo-upload-client";

export const showRootMenu = makeVar(false);
export const shipmentVar = makeVar(null);

export const cache = new InMemoryCache({
  typePolicies: {
    ProductType: {
      fields: {
        imageUrls: {
          merge: false, // Always replace, no warning
        },
      },
    },
  },
});

const httpLinkWithUpload = createUploadLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
  credentials: "include",
});

const errorLink = onError((error) => {
  const { graphQLErrors, networkError } = error;
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message }) => {
      console.log(`[GraphQL error]: ${message}`);
    });
  }

  if (networkError) {
    console.log(`[Network error]: ${networkError}`);
  }
});

const link = from([errorLink, httpLinkWithUpload]);

export const parseError = (error) => {
  if (!error) return "";

  // if error is a string, return it directly
  if (typeof error === "string") return error;

  if (error.graphQLErrors && error.graphQLErrors.length > 0) {
    console.log("error.graphQLErrors", error.graphQLErrors);
    return error.graphQLErrors.map((e) => e.message).join("\n");
  } else if (
    error.networkError &&
    error.networkError.result &&
    error.networkError.result.errors &&
    error.networkError.result.errors.length > 0
  ) {
    console.log(
      "error.networkError.result.errors",
      error.networkError.result.errors,
    );
    return error.networkError.result.errors.map((e) => e.message).join("\n");
  }

  if (error.message === "Failed to fetch") {
    return "Network error: Failed to connect. Please check your internet connection or try again later.";
  }

  return error.message;
};

export const client = new ApolloClient({ link, cache });

// Recursively remove __typename from any nested object/array
export function removeTypename(value) {
  if (Array.isArray(value)) {
    return value.map(removeTypename);
  }

  if (value && typeof value === "object") {
    const result = {};
    for (const [key, v] of Object.entries(value)) {
      if (key === "__typename") continue;
      result[key] = removeTypename(v);
    }
    return result;
  }

  return value;
}
